import React from 'react';
import { PropTypes } from 'prop-types';

import CaseStudyHeader from '../Header';
import MainImage from '../MainImage';
import Reference from '../Reference';
import Device from '../Device';
import LastImage from './LastImage';

const Slide = ({
    styles,
    heading,
    subHeading,
    tags,
    link,
    isMoving,
    transitionDuration,
    reference,
    deviceImage,
    deviceAlt,
    deviceType,
    mainImage,
    moveToNextSlide,
    moveToNextSlideMobile,
    isActive,
    mainImageActive,
    isLast,
    logo,
}) => (
    <div data-event-id="carousel-slide" className={styles.container}>
        <CaseStudyHeader
            {...{
                heading,
                subHeading,
                tags,
                link,
                isMoving,
                isActive,
                transitionDuration,
                moveToNextSlide,
                moveToNextSlideMobile,
                isLast,
                logo,
            }}
        />
        <div className={styles.imagesContainer}>
            {!isLast ? (
                <>
                    <Reference content={reference} logo={logo} />
                    <MainImage
                        isMoving={isMoving}
                        transitionDuration={transitionDuration}
                        src={mainImage}
                        isActive={mainImageActive}
                    />
                    <Device
                        isMoving={isMoving}
                        isActive={isActive}
                        transitionDuration={transitionDuration}
                        alt={deviceAlt}
                        src={deviceImage}
                        deviceType={deviceType}
                        isLast={isLast}
                    />
                </>
            ) : (
                <LastImage />
            )}
        </div>
    </div>
);

Slide.propTypes = {
    styles: PropTypes.shape({
        container: PropTypes.string.isRequired,
    }).isRequired,
    heading: PropTypes.string.isRequired,
    subHeading: PropTypes.string.isRequired,
    tags: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    isMoving: PropTypes.bool.isRequired,
    transitionDuration: PropTypes.number.isRequired,
    reference: PropTypes.shape().isRequired,
    deviceImage: PropTypes.string.isRequired,
    deviceAlt: PropTypes.string.isRequired,
    deviceType: PropTypes.string.isRequired,
    mainImage: PropTypes.string.isRequired,
    moveToNextSlide: PropTypes.func.isRequired,
    isActive: PropTypes.bool.isRequired,
};

export default Slide;
